import {
  createTPluginFactory,
} from '../../plate';
import { KEY_INTERNAL_LINK } from '../../pluginKeys';
import { InternalLinkOptions } from './types';

export const createInternalLinkPlugin = createTPluginFactory<InternalLinkOptions>({
  key: KEY_INTERNAL_LINK,
  options: {
    pagesPaths: {},
  },
});
